import "./styling/global.css";
import ReactDOM from "react-dom";
import { forceRenderStyles } from "typestyle";

import { StrictMode } from "react";
import { Main } from "./components/main";
import { TestEnvironmentBar } from "./components/statics/test-environment-bar.static";
import Toast from "./components/statics/toast";

ReactDOM.render(
  <StrictMode>
    <Main />
    <TestEnvironmentBar />
    <Toast />
  </StrictMode>,
  document.getElementById("root"),
);
forceRenderStyles();
